export default __webpack_public_path__ + "static/retreat_7-127198d48c3f0039cbad64b1dc682940.jpg";